import { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import "../withdraw/withdraw.css";

function Promo({ profile, getProfile }) {
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [payment, setPayment] = useState(null);
    const [myPromos, setMyPromos] = useState([]);

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm();

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const navigate = useNavigate();

    // ==========================================
    // TÁCH HÀM FETCH DỮ LIỆU ĐỂ TÁI SỬ DỤNG
    // ==========================================
    const fetchPayments = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/payment/paymentus`, {})
            .then((res) => {
                setPayment(res.data.data);
            })
            .catch((err) => console.log(err));
    };

 const fetchMyPromos = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/promo/my-promo`, {})
            .then((res) => {
                if(res.data.success) {
                    // LỌC MÃ: Chỉ giữ lại những mã KHÔNG dùng chung
                    const privatePromos = res.data.data.filter((promo) => {
                        // Tùy thuộc vào cột phân loại trong Database của bạn là gì (type, username, user_id...)
                        // Dưới đây là các điều kiện loại bỏ mã chung (thường mang giá trị 'all' hoặc 'chung')
                        const isNotAllType = promo.type !== 'all' && promo.type !== 'chung';
                        const isNotAllUser = promo.username !== 'all' && promo.username !== 'chung';
                        
                        // Bạn cũng có thể check điều kiện: mã phải khớp với username/id của user hiện tại
                        // Ví dụ: return promo.username === profile?.username;

                        return isNotAllType && isNotAllUser;
                    });
                    
                    setMyPromos(privatePromos);
                }
            })
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            if (setting !== res.data.data[0]) {
                setSetting(res.data.data[0]);
                localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
            }
        });
        
        // Gọi dữ liệu lần đầu tiên khi vào trang
        fetchPayments();
        fetchMyPromos();
    }, []);

    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    // ==========================================
    // XỬ LÝ COPY MÃ
    // ==========================================
    const handleCopy = (e, code) => {
        e.stopPropagation(); // Ngăn chặn sự kiện click lan ra thẻ cha (không bị tự điền mã khi chỉ muốn copy)
        navigator.clipboard.writeText(code);
        swal("Thành công", `Đã sao chép mã: ${code}`, "success", {
            timer: 1500, // Tự tắt sau 1.5s cho mượt
            buttons: false
        });
    };

    const activeCode = (data) => {
        if (data.code === "") {
            swal("Thông báo", "Vui lòng nhập đầy đủ thông tin", "warning");
            return;
        }
        
        axios.post(`${process.env.REACT_APP_API_URL}/promo/active`, {code: data.code})
            .then((res) => {
                swal("Thành Công", `Mã khuyến mãi đã được áp dụng thành công! Bạn đã nhận được ${res.data.data.money.toLocaleString('vi-VN')}₫.`, "success");
                
                // CẬP NHẬT DỮ LIỆU TỰ ĐỘNG KHÔNG CẦN LOAD TRANG
                getProfile(); // Cập nhật lại số dư trên Header
                fetchPayments(); // Lấy lại lịch sử khuyến mãi
                fetchMyPromos(); // Cập nhật lại danh sách mã để xóa mã vừa dùng đi
                setValue("code", ""); // Xóa rỗng ô nhập mã
            })
            .catch((err) => swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã xảy ra lỗi", "error"));
    };

    return (
        <div className="withdraw">
            {profile && (
                <>
                    <div className="withdraw-header">
                        <div className="menu-item-withdraw active">Nhập mã khuyến mãi</div>
                    </div>
                    <div className="withdraw-grid">
                        <div className="withdraw-grid-content">
                            <form onSubmit={handleSubmit(activeCode)}>
                                <div className="inputs">
                                    <div className="input">
                                        <label>Mã khuyến mãi</label>
                                        <input className="ipadd" type="text" {...register("code")} placeholder="Vui lòng nhập mã khuyến mãi" />
                                    </div>
                                    <button type="submit" className="btn-red">
                                        Áp dụng
                                    </button>
                                </div>
                            </form>
                            
                            <div className="widthdraw-history" style={{ marginTop: '20px' }}>
                                <div className="history-title" style={{ color: '#4caf50' }}>Mã Khuyến Mãi Dành Cho Bạn</div>
                                <div className="history-list">
                                    {myPromos && myPromos.length > 0 ? (
                                        myPromos.map((promo, key) => (
                                            <div className="js-withdraw-history" key={key} style={{ cursor: 'pointer', transition: '0.3s' }} onClick={() => setValue("code", promo.code)}>
                                                <div className="item-inner">
                                                    <div className="item_history" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <div>
                                                            <span className="money" style={{ fontWeight: 'bold' }}>{promo.code}</span>
                                                            <span className="text_status win" style={{ border: '1px solid #4caf50', padding: '2px 8px', borderRadius: '4px', marginLeft: '10px' }}>
                                                                +{Math.floor(promo.money).toLocaleString("vi-VN")}₫
                                                            </span>
                                                        </div>
                                                        
                                                        {/* NÚT SAO CHÉP */}
                                                        <button 
                                                            onClick={(e) => handleCopy(e, promo.code)}
                                                            style={{
                                                                padding: '6px 12px',
                                                                background: '#f1f1f1',
                                                                color: '#333',
                                                                border: '1px solid #ccc',
                                                                borderRadius: '4px',
                                                                cursor: 'pointer',
                                                                fontSize: '12px',
                                                                fontWeight: 'bold'
                                                            }}
                                                        >
                                                            Sao chép
                                                        </button>
                                                    </div>
                                                    <div className="time_history" style={{ color: '#888', fontStyle: 'italic', marginTop: '5px' }}>
                                                        Bấm vào khung này để tự điền mã
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div style={{ padding: '15px', textAlign: 'center', color: '#999', fontSize: '14px' }}>
                                            Hiện tại không có mã nào dành cho bạn.
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                        
                        <div className="widthdraw-history">
                            <div className="history-title">Lịch sử khuyến mãi</div>
                            <div className="history-list">
                                {payment?.map((item, key) => (
                                    <div key={key}>
                                        {item?.type_payment === "ƯU ĐÃI" && (
                                            <div className="js-withdraw-history">
                                                <div className="item-inner">
                                                    <div className="item_history">
                                                        <span className="money">{Math.floor(item?.money).toLocaleString("vi-VN")}₫</span>
                                                        <span
                                                            className={`text_status ${
                                                                item?.status_payment === "Pending" ? "pending" : item?.status_payment === "Success" ? "win" : "lose"
                                                            }`}>
                                                            {item?.status_payment === "Pending" ? "Chờ xử lý" : item?.status_payment === "Success" ? "Thành công" : "Thất bại"}
                                                        </span>
                                                    </div>
                                                    <div className="time_history">{formatDate(new Date(item?.createdAt))}</div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default Promo;